<html>

<head>
    <title>Perfect Numbers | Login</title>
</head>
<ng-container *ngIf="error429Message !== ''">

    <head>
        <title>Error</title>
    </head>
    <div class="error-container">
        <div class="mensaje-error-container">
            <div class="mensaje-error">{{ error429Message }}</div>
            <mat-progress-bar mode="indeterminate" class="progress-bar" color="warn"></mat-progress-bar>
        </div>
    </div>
</ng-container>

<body *ngIf="error429Message === '' && (token && token.csrf_token)">
    <h1 class="title">Data<span class="beer">Beer</span></h1>
    <mat-card>
        <mat-card-header>
            <mat-card-title class="text">Iniciar sesión</mat-card-title>
        </mat-card-header>

        <mat-card-content>
            <form [formGroup]="signin" (submit)="login()">
                <input type="hidden" name="_token" [value]='token.csrf_token'>
                <mat-form-field appearance="outline" hideRequiredMarker class="form-field1">
                    <mat-label>Email</mat-label>
                    <input matInput placeholder="nombre@ejemplo.com" formControlName="email" autocomplete="email"
                        required>
                    <mat-icon matPrefix>person</mat-icon>
                    <mat-error *ngIf="emailError.invalid">{{getErrorMessageEmail()}}</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" hideRequiredMarker class="form-field2">
                    <mat-label>Contraseña</mat-label>
                    <input matInput [type]="hide ? 'password' : 'text'" placeholder="Introduce tu contraseña"
                        formControlName="password" autocomplete="current-password" required>
                    <mat-icon matPrefix>lock</mat-icon>
                    <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    <mat-error *ngIf="emailError.invalid">{{getErrorMessagePassword()}}</mat-error>
                </mat-form-field>

                <div class="error-container1">
                    <div *ngIf=errorVisible class="error-message">
                        {{ errorMessage }}
                    </div>
                </div>
                <button mat-raised-button class="login-btn" type="submit">Iniciar sesión</button>
                <a mat-button routerLink="/olvido-contraseña" class="forgot-password-link" [disabled]="true">¿Olvidó la
                    contraseña?</a>
            </form>
            <div class="divider">
                <span></span>
                <p>o</p>
                <span></span>
            </div>

            <!-- Login Microsoft-->
            <button mat-stroked-button color="primary" class="login-alt-btn" (click)="loginMicrosoft()">
                Iniciar sesión con Microsoft
            </button>
        </mat-card-content>
    </mat-card>
</body>

</html>